import { render, staticRenderFns } from "./CorpManningVesselsList.vue?vue&type=template&id=515dabc2"
import script from "./CorpManningVesselsList.vue?vue&type=script&lang=js"
export * from "./CorpManningVesselsList.vue?vue&type=script&lang=js"
import style0 from "./CorpManningVesselsList.vue?vue&type=style&index=0&id=515dabc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports